/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
/* eslint-disable operator-linebreak */
/* eslint-disable eol-last */
/* eslint-disable comma-dangle */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-underscore-dangle */
/* eslint-disable object-curly-newline */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable quotes */
import React, { useMemo, useRef, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import dayjs from "dayjs";

const CAT_STYLE = {
    pronaret: { color: "#5a9b3a", bg: "#e8f5ee", chip: "#437a28" },
    bordi: { color: "#888888", bg: "#f1f1f1", chip: "#5f5f5f" },
    perfaqesuesit: { color: "#668caf", bg: "#e8eef8", chip: "#4a6c8f" },
    kapital: { color: "#6667af", bg: "#ece8f8", chip: "#6667af" },
    biznes: { color: "#d97706", bg: "#fef3c7", chip: "#b45309" },
    emri: { color: "#0e7490", bg: "#cffafe", chip: "#0e7490" },
    adresa: { color: "#be185d", bg: "#fce7f3", chip: "#be185d" },
    nrpuntoreve: { color: "#9333ea", bg: "#f3e8ff", chip: "#9333ea" },
};

const ENDED_COLOR = "#dc2626";
const ENDED_CHIP = "#b91c1c";
const hasEndDate = (ev) => !!(ev && ev.dateEnd && ev.dateEnd.isValid && ev.dateEnd.isValid());
const isEnded = (ev) => !!(ev && (hasEndDate(ev) || ev.endUnknown));
const catColor = (ev) => (isEnded(ev) ? ENDED_COLOR : (CAT_STYLE[ev.cat] || CAT_STYLE.biznes).color);
const catChip = (ev) => (isEnded(ev) ? ENDED_CHIP : (CAT_STYLE[ev.cat] || CAT_STYLE.biznes).chip);

const MAX_TEXT_LEN = 30;

const AXIS_COLOR = "#4472c4";
const PAD_X = 28;
const MIN_LAYOUT_W = 680;
const EMPTY_YEAR_MIN_W = 26;
const EMPTY_YEAR_MAX_W = 48;
const GAP_MIN_W = 14;
const GAP_MAX_W = 80;
const DOT_R = 8;
const MIN_DOT_GAP = 22;
const TICK_H = 22;
const CHIP_H = 26;
const LANE_GAP = 12;
const CHIP_GAP = 10;
const ABOVE_BASE = 52;
const BELOW_BASE = 84;
const ELBOW_OFF = 14;

const trunc = (str, max) => (str && str.length > max ? `${str.slice(0, max - 1)}…` : str || "");

const flagPath = (countryCode) => `/images/flags/${(countryCode || "xx").toString().trim().toLowerCase()}.svg`;

const FlagImg = ({ code }) => (
    <img
        src={flagPath(code)}
        alt={code}
        width={18}
        height={13}
        onError={(event) => {
            if (event.currentTarget.src.indexOf("/images/flags/xx.svg") !== -1) return;
            event.currentTarget.src = "/images/flags/xx.svg";
        }}
        style={{ flexShrink: 0, objectFit: "cover", borderRadius: 2, border: "1px solid #e5e7eb" }}
    />
);

const stripCountryCode = (name, code) => {
    let n = (name || "").trim();
    if (!n) return "";
    const c = (code || "").trim();
    if (c) {
        const esc = c.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        n = n.replace(new RegExp(`,\\s*${esc}\\s*$`, "i"), "").trim();
    }
    return n.replace(/,\s*[A-Za-z]{2}\s*$/, "").trim();
};

const countryName = (h, locale) => {
    let name = "";
    if (locale === "en") name = h.shtetiEN || h.ShtetiEN || h.shtetiSQ || h.ShtetiSQ || h.shtetiSR || h.ShtetiSR || "";
    else if (locale === "sr") name = h.shtetiSR || h.ShtetiSR || h.shtetiSQ || h.ShtetiSQ || h.shtetiEN || h.ShtetiEN || "";
    else name = h.shtetiSQ || h.ShtetiSQ || h.shtetiEN || h.ShtetiEN || h.shtetiSR || h.ShtetiSR || "";
    return stripCountryCode(name, h.codeShteti || h.CodeShteti);
};

const addressRow = (h, locale, lbl) => {
    const addr = h.adresa != null && String(h.adresa).trim() ? String(h.adresa).trim() : "";
    const value = addr || countryName(h, locale);
    if (!value) return null;
    return { label: lbl.tipAddress, value, flag: h.codeShteti || h.CodeShteti || "" };
};

const fmtNum = (n) => {
    if (n == null || n === "") return "";
    const num = parseFloat(n);
    if (Number.isNaN(num)) return n;
    return num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const chipWidth = (text) => Math.min(244, Math.round(text.length * 6.6) + 22);

const EMPTY_ARR = [];
const EMPTY_OBJ = {};

const TimelineChart = ({
    pronaretHistoria = EMPTY_ARR,
    perfaqesuesitHistoria = EMPTY_ARR,
    bordiHistoria = EMPTY_ARR,
    kapitaliHistoria = EMPTY_ARR,
    emriHistoria = EMPTY_ARR,
    adresaHistoria = EMPTY_ARR,
    nrpuntoreveHistoria = EMPTY_ARR,
    customEvents = EMPTY_ARR,
    labels = EMPTY_OBJ,
    locale = "sq",
}) => {
    const wrapRef = useRef(null);
    const [containerW, setContainerW] = useState(0);
    const [hover, setHover] = useState(null);

    const showTip = (ev, side) => (e) => {
        const r = e.currentTarget.getBoundingClientRect();
        setHover({ ev, side, cx: r.left + r.width / 2, top: r.top, bottom: r.bottom });
    };

    useEffect(() => {
        if (!hover) return undefined;
        const clear = () => setHover(null);
        window.addEventListener("scroll", clear, true);
        return () => window.removeEventListener("scroll", clear, true);
    }, [hover]);

    const lbl = useMemo(
        () => ({
            tipName: labels.tipName || "Emri",
            tipSurname: labels.tipSurname || "Mbiemri",
            tipCapital: labels.tipCapital || "Kapitali",
            tipCapitalPct: labels.tipCapitalPct || "Kapitali %",
            tipAddress: labels.tipAddress || "Adresa",
            tipPosition: labels.tipPosition || "Pozita",
            tipDate: labels.tipDate || "Data",
            tipDateFrom: labels.tipDateFrom || labels.tipDate || "Data prej",
            tipDateTo: labels.tipDateTo || "Data deri",
            tipNui: labels.tipNui || "NUI",
            tipPeriudha: labels.tipPeriudha || "Periudha",
            tipVazhdon: labels.tipVazhdon || "Vazhdon",
            tipData: labels.tipData || "Data",
            tipNA: labels.tipNA || "N/A",
            pronaret: labels.pronaret || "Pronaret",
            bordi: labels.bordi || "Bordi",
            perfaqesuesit: labels.perfaqesuesit || "Perfaqesuesit",
            kapital: labels.kapital || "Kapitali",
            biznes: labels.biznes || "Biznesi",
            emri: labels.emri || "Emërtimi",
            adresa: labels.adresa || "Adresa",
            nrpuntoreve: labels.nrpuntoreve || "Numri i punëtorëve",
            ended: labels.ended || (locale === "en" ? "Ended" : locale === "sr" ? "Završeno" : "Përfunduar"),
        }),
        [labels, locale]
    );

    useEffect(() => {
        if (!wrapRef.current) return undefined;
        const observer = new ResizeObserver((entries) => {
            const w = entries[0]?.contentRect?.width || 0;
            if (w > 0) setContainerW(w);
        });
        observer.observe(wrapRef.current);
        return () => observer.disconnect();
    }, []);

    const allEvents = useMemo(() => {
        const ev = [];
        const endInfo = (raw, startD) => {
            if (!raw) return { dateEnd: null, endUnknown: false };
            const e = dayjs(raw);
            if (!e.isValid()) return { dateEnd: null, endUnknown: false };
            if (e.year() <= 1900) return { dateEnd: null, endUnknown: true };
            if (e.valueOf() === startD.valueOf()) return { dateEnd: null, endUnknown: false };
            return { dateEnd: e, endUnknown: false };
        };

        pronaretHistoria.forEach((h) => {
            const d = h.dtPrej ? dayjs(h.dtPrej) : null;
            if (!d?.isValid()) return;
            const text = trunc(h.pronari || "", MAX_TEXT_LEN);
            if (!text) return;
            const parts = (h.pronari || "").trim().split(/\s+/);
            const emri = parts[0] || "";
            const mbiemri = parts.slice(1).join(" ");
            ev.push({
                date: d,
                ...endInfo(h.dtDeri, d),
                text,
                cat: "pronaret",
                tip: {
                    title: h.pronari || "",
                    badge: h.llojiAksionarit || "",
                    rows: [
                        emri && { label: lbl.tipName, value: emri },
                        mbiemri && { label: lbl.tipSurname, value: mbiemri },
                        (h.fizik === false || h.Fizik === false) && (h.NUI || h.nui) && { label: lbl.tipNui, value: String(h.NUI || h.nui) },
                        h.kapitali && { label: lbl.tipCapital, value: `${fmtNum(h.kapitali)} €` },
                        h.kapitaliPerqindje && { label: lbl.tipCapitalPct, value: `${fmtNum(h.kapitaliPerqindje)} %` },
                        addressRow(h, locale, lbl),
                    ].filter(Boolean),
                },
            });
        });

        bordiHistoria.forEach((h) => {
            const d = h.dtPrej ? dayjs(h.dtPrej) : null;
            if (!d?.isValid()) return;
            const name = trunc(`${(h.emri || "").trim()} ${(h.mbiemri || "").trim()}`.trim(), 20);
            const pos = trunc(h.pozita || "", 16);
            const text = trunc(pos ? `${pos}: ${name}` : name, MAX_TEXT_LEN);
            if (!text) return;
            ev.push({
                date: d,
                ...endInfo(h.dtDeri, d),
                text,
                cat: "bordi",
                tip: {
                    title: `${h.emri || ""} ${h.mbiemri || ""}`.trim(),
                    badge: h.pozita || "",
                    rows: [
                        h.emri && { label: lbl.tipName, value: h.emri.trim() },
                        h.mbiemri && { label: lbl.tipSurname, value: h.mbiemri.trim() },
                        h.pozita && { label: lbl.tipPosition, value: h.pozita },
                        addressRow(h, locale, lbl),
                    ].filter(Boolean),
                },
            });
        });

        perfaqesuesitHistoria.forEach((h) => {
            const d = h.dtPrej ? dayjs(h.dtPrej) : null;
            if (!d?.isValid()) return;
            const name = trunc(`${(h.emri || "").trim()} ${(h.mbiemri || "").trim()}`.trim(), 20);
            const pos = trunc(h.pozita || "", 16);
            const text = trunc(pos ? `${pos}: ${name}` : name, MAX_TEXT_LEN);
            if (!text) return;
            ev.push({
                date: d,
                ...endInfo(h.dtDeri, d),
                text,
                cat: "perfaqesuesit",
                tip: {
                    title: `${h.emri || ""} ${h.mbiemri || ""}`.trim(),
                    badge: h.pozita || "",
                    rows: [
                        h.emri && { label: lbl.tipName, value: h.emri.trim() },
                        h.mbiemri && { label: lbl.tipSurname, value: h.mbiemri.trim() },
                        h.pozita && { label: lbl.tipPosition, value: h.pozita },
                        addressRow(h, locale, lbl),
                    ].filter(Boolean),
                },
            });
        });

        kapitaliHistoria.forEach((h) => {
            const dateStr = h.dtDeri || h.dtPrej;
            const d = dateStr ? dayjs(dateStr) : null;
            if (!d?.isValid()) return;
            const text = trunc(h.kapitali || "", MAX_TEXT_LEN);
            if (!text) return;
            ev.push({
                date: d,
                text,
                cat: "kapital",
                tip: {
                    title: lbl.kapital,
                    badge: "",
                    rows: [h.kapitali && { label: "", value: h.kapitali }].filter(Boolean),
                },
            });
        });

        const changeLog = (arr, cat) => {
            arr.forEach((h) => {
                const startStr = h.dtPrej || h.dtDeri;
                const d = startStr ? dayjs(startStr) : null;
                if (!d?.isValid()) return;
                const full = (h.Ndryshimet || h.ndryshimet || "").trim();
                const text = trunc(full, MAX_TEXT_LEN);
                if (!text) return;
                ev.push({
                    date: d,
                    ...(h.dtPrej ? endInfo(h.dtDeri, d) : { dateEnd: null, endUnknown: false }),
                    text,
                    cat,
                    tip: {
                        title: lbl[cat],
                        badge: "",
                        rows: [full && { label: "", value: full }].filter(Boolean),
                    },
                });
            });
        };
        changeLog(emriHistoria, "emri");
        changeLog(adresaHistoria, "adresa");
        changeLog(nrpuntoreveHistoria, "nrpuntoreve");

        customEvents.forEach((c) => {
            const d = c.date ? dayjs(c.date) : null;
            if (!d?.isValid()) return;
            const text = trunc(c.text || "", MAX_TEXT_LEN);
            if (!text) return;
            ev.push({
                date: d,
                text,
                cat: c.cat || "biznes",
                priority: c.priority || 0,
                singleDate: !!c.singleDate,
                tip: c.tip || { title: c.text || "", badge: "", rows: [] },
            });
        });

        const sorted = ev.sort((a, b) => {
            const byDate = a.date.valueOf() - b.date.valueOf();
            if (byDate !== 0) return byDate;
            return (a.priority || 0) - (b.priority || 0);
        });
        return sorted.map((e, idx) => ({ ...e, _key: idx }));
    }, [pronaretHistoria, perfaqesuesitHistoria, bordiHistoria, kapitaliHistoria, emriHistoria, adresaHistoria, nrpuntoreveHistoria, customEvents, lbl, locale]);

    const layout = useMemo(() => {
        if (!allEvents.length) return null;

        const availW = Math.max(containerW || 900, MIN_LAYOUT_W);

        const evYears = allEvents.map((e) => e.date.year());
        const endYears = allEvents
            .filter((e) => e.dateEnd && e.dateEnd.isValid())
            .map((e) => e.dateEnd.year());
        const boundYears = evYears.concat(endYears);
        const minYear = Math.min(...boundYears) - 2;
        const maxYear = Math.max(...boundYears) + 2;
        const years = [];
        for (let y = minYear; y <= maxYear; y += 1) years.push(y);

        const countByYear = {};
        evYears.forEach((y) => {
            countByYear[y] = (countByYear[y] || 0) + 1;
        });

        const anchors = [];
        for (let y = minYear; y <= maxYear + 1; y += 1) {
            anchors.push({ t: dayjs(`${y}-01-01`).valueOf(), kind: "b", year: y });
        }
        allEvents.forEach((ev) => anchors.push({ t: ev.date.valueOf(), kind: "e", key: ev._key }));
        anchors.sort((a, b) => {
            if (a.t !== b.t) return a.t - b.t;
            if (a.kind !== b.kind) return a.kind === "b" ? -1 : 1;
            return (a.key || 0) - (b.key || 0);
        });

        const n = anchors.length - 1;
        const durs = [];
        const floors = [];
        const caps = [];
        for (let i = 0; i < n; i += 1) {
            const L = anchors[i];
            const R = anchors[i + 1];
            durs.push(Math.max(R.t - L.t, 0));
            if (L.kind === "e" && R.kind === "e") {
                floors.push(MIN_DOT_GAP);
                caps.push(GAP_MAX_W);
            } else if (L.kind === "e" || R.kind === "e") {
                floors.push(GAP_MIN_W);
                caps.push(GAP_MAX_W);
            } else {
                floors.push(EMPTY_YEAR_MIN_W);
                caps.push(EMPTY_YEAR_MAX_W);
            }
        }

        const innerW = availW - PAD_X * 2;
        const widths = floors.slice();
        const free = durs.map(() => true);
        for (let pass = 0; pass < n; pass += 1) {
            let pinnedW = 0;
            let freeD = 0;
            for (let i = 0; i < n; i += 1) {
                if (free[i]) freeD += durs[i];
                else pinnedW += widths[i];
            }
            if (freeD <= 0) {
                for (let i = 0; i < n; i += 1) {
                    if (free[i]) {
                        widths[i] = floors[i];
                        free[i] = false;
                    }
                }
                break;
            }
            let changed = false;
            for (let i = 0; i < n; i += 1) {
                if (free[i]) {
                    const w = ((innerW - pinnedW) * durs[i]) / freeD;
                    if (w < floors[i]) {
                        widths[i] = floors[i];
                        free[i] = false;
                        changed = true;
                    } else if (w > caps[i]) {
                        widths[i] = caps[i];
                        free[i] = false;
                        changed = true;
                    } else {
                        widths[i] = w;
                    }
                }
            }
            if (!changed) break;
        }
        const sumW = widths.reduce((a, b) => a + b, 0);
        if (sumW < innerW) {
            const stretchIdx = [];
            for (let i = 0; i < n; i += 1) {
                if (anchors[i].kind === "e" || anchors[i + 1].kind === "e") stretchIdx.push(i);
            }
            const base = stretchIdx.reduce((acc, i) => acc + widths[i], 0);
            if (base > 0) {
                const factor = (innerW - sumW) / base;
                stretchIdx.forEach((i) => {
                    widths[i] += widths[i] * factor;
                });
            }
        }

        const pos = [PAD_X];
        for (let i = 0; i < n; i += 1) pos.push(pos[i] + widths[i]);
        const totalW = pos[n] + PAD_X;

        const tickByYear = {};
        const dotByKey = {};
        anchors.forEach((a, i) => {
            if (a.kind === "b") tickByYear[a.year] = pos[i];
            else dotByKey[a.key] = pos[i];
        });
        const dots = allEvents.map((ev) => ({ ev, x: dotByKey[ev._key] }));

        const interpX = (d) => {
            const y = d.year();
            const x0 = tickByYear[y];
            const x1 = tickByYear[y + 1];
            if (x0 == null) return null;
            if (x1 == null) return x0;
            const t0 = dayjs(`${y}-01-01`).valueOf();
            const t1 = dayjs(`${y + 1}-01-01`).valueOf();
            const frac = Math.min(Math.max((d.valueOf() - t0) / (t1 - t0), 0), 1);
            return x0 + frac * (x1 - x0);
        };
        const ranges = dots
            .filter((d) => d.ev.dateEnd && d.ev.dateEnd.isValid && d.ev.dateEnd.isValid())
            .map((d) => {
                const ex = interpX(d.ev.dateEnd);
                if (ex == null) return null;
                const x0 = Math.min(d.x, ex);
                const x1 = Math.max(d.x, ex);
                if (x1 - x0 < 2) return null;
                return { x0, x1, color: ENDED_COLOR, key: d.ev._key };
            })
            .filter(Boolean);

        const segX = years.map((y) => ({
            year: y,
            x0: tickByYear[y],
            x1: tickByYear[y + 1],
            count: countByYear[y] || 0,
        }));

        const lanes = { above: [], below: [] };
        const chips = dots.map((d, i) => {
            const side = i % 2 === 0 ? "above" : "below";
            const w = chipWidth(d.ev.text);
            const ideal = Math.min(Math.max(d.x - w / 2, 8), totalW - w - 8);
            const sideLanes = lanes[side];
            let lane = sideLanes.findIndex((end) => ideal >= end + CHIP_GAP);
            if (lane === -1) {
                lane = sideLanes.length;
                sideLanes.push(0);
            }
            sideLanes[lane] = ideal + w;
            return { ev: d.ev, dotX: d.x, side, lane, x: ideal, w };
        });

        const aboveLanes = lanes.above.length;
        const belowLanes = lanes.below.length;
        const axisY = 16 + ABOVE_BASE + Math.max(aboveLanes, 1) * (CHIP_H + LANE_GAP);
        const height = axisY + BELOW_BASE + Math.max(belowLanes, 1) * (CHIP_H + LANE_GAP) + 8;

        const chipTop = (side, lane) =>
            side === "above"
                ? axisY - ABOVE_BASE - CHIP_H - lane * (CHIP_H + LANE_GAP)
                : axisY + BELOW_BASE + lane * (CHIP_H + LANE_GAP);
        const placedChips = chips.map((c) => ({ ...c, y: chipTop(c.side, c.lane) }));

        const connectors = placedChips.map((c, i) => {
            const cxChip = c.x + c.w / 2;
            const color = catColor(c.ev);
            const jitter = (i % 3) * 5;
            if (c.side === "above") {
                const edgeY = c.y + CHIP_H;
                const midY = edgeY + ELBOW_OFF + jitter;
                const straight = Math.abs(cxChip - c.dotX) < 6;
                const dPath = straight
                    ? `M ${c.dotX} ${axisY - DOT_R - 2} L ${c.dotX} ${edgeY + 6}`
                    : `M ${c.dotX} ${axisY - DOT_R - 2} L ${c.dotX} ${midY} L ${cxChip} ${midY} L ${cxChip} ${edgeY + 6}`;
                return { d: dPath, color, arrow: `${cxChip},${edgeY + 1} ${cxChip - 4},${edgeY + 7} ${cxChip + 4},${edgeY + 7}` };
            }
            const edgeY = c.y;
            const midY = edgeY - ELBOW_OFF - jitter;
            const straight = Math.abs(cxChip - c.dotX) < 6;
            const dPath = straight
                ? `M ${c.dotX} ${axisY + DOT_R + 2} L ${c.dotX} ${edgeY - 6}`
                : `M ${c.dotX} ${axisY + DOT_R + 2} L ${c.dotX} ${midY} L ${cxChip} ${midY} L ${cxChip} ${edgeY - 6}`;
            return { d: dPath, color, arrow: `${cxChip},${edgeY - 1} ${cxChip - 4},${edgeY - 7} ${cxChip + 4},${edgeY - 7}` };
        });

        const minEmptyW = Math.min(...segX.filter((s) => !s.count).map((s) => s.x1 - s.x0), Infinity);
        const labelStep = minEmptyW < 36 ? Math.ceil(36 / Math.max(minEmptyW, 1)) : 1;
        let emptyIdx = 0;
        const bigXs = segX.filter((s) => s.count).map((s) => s.x0);
        const yearLabels = segX.map((s) => {
            const x = Math.min(Math.max(s.x0, 42), totalW - 42);
            if (s.count) return { year: s.year, x, big: true, show: true };
            const boundary = dayjs(`${s.year}-01-01`);
            const nearDot = allEvents.some((e2) => Math.abs(e2.date.diff(boundary, "day")) <= 92);
            if (nearDot && bigXs.every((bx) => Math.abs(bx - s.x0) >= 64)) {
                bigXs.push(s.x0);
                return { year: s.year, x, big: true, show: true };
            }
            const show = emptyIdx % labelStep === 0;
            emptyIdx += 1;
            return { year: s.year, x, big: false, show };
        });

        const ticks = segX.map((s) => s.x0).concat(segX[segX.length - 1].x1);

        return { totalW, height, axisY, dots, chips: placedChips, connectors, yearLabels, ticks, ranges };
    }, [allEvents, containerW]);

    useEffect(() => {
        setHover(null);
    }, [layout]);

    if (!allEvents.length || !layout) return null;

    const presentCats = [...new Set(allEvents.map((e) => e.cat))];
    const hasEnded = allEvents.some(isEnded);
    const { totalW, height, axisY } = layout;

    const tip = hover ? hover.ev.tip : null;
    const tipCfg = hover ? CAT_STYLE[hover.ev.cat] || CAT_STYLE.biznes : null;
    const tipColor = hover ? catColor(hover.ev) : null;

    return (
        <div ref={wrapRef} className="tw-w-full tw-min-w-0 tw-max-w-full tw-relative">
            {(presentCats.length > 1 || hasEnded) && (
                <div className="tw-flex tw-gap-4 tw-mb-2 tw-flex-wrap">
                    {presentCats.map((cat) => {
                        const cfg = CAT_STYLE[cat];
                        return (
                            <div key={cat} className="tw-flex tw-items-center tw-gap-1.5 tw-text-xs">
                                <div
                                    className="tw-w-2.5 tw-h-2.5 tw-rounded tw-flex-shrink-0"
                                    style={{ background: cfg.color }}
                                />
                                <span className="tw-font-medium" style={{ color: "#334155" }}>{lbl[cat]}</span>
                            </div>
                        );
                    })}
                    {hasEnded && (
                        <div className="tw-flex tw-items-center tw-gap-1.5 tw-text-xs">
                            <div
                                className="tw-w-2.5 tw-h-2.5 tw-rounded tw-flex-shrink-0"
                                style={{ background: ENDED_COLOR }}
                            />
                            <span className="tw-font-medium" style={{ color: "#334155" }}>{lbl.ended}</span>
                        </div>
                    )}
                </div>
            )}

            <div className="tw-overflow-x-auto tw-overflow-y-hidden" style={{ WebkitOverflowScrolling: "touch", touchAction: "pan-x" }}>
                <div className="tw-relative" style={{ width: totalW, height, minWidth: "100%" }}>
                    <svg
                        width={totalW}
                        height={height}
                        className="tw-absolute tw-pointer-events-none"
                        style={{ left: 0, top: 0 }}
                    >
                        {layout.connectors.map((c, i) => (
                            <g key={i}>
                                <path d={c.d} fill="none" stroke={c.color} strokeWidth="1.4" opacity="0.8" />
                                <polygon points={c.arrow} fill={c.color} opacity="0.9" />
                            </g>
                        ))}
                    </svg>

                    <div
                        className="tw-absolute tw-rounded-full"
                        style={{ left: 0, right: 0, top: axisY - 2, height: 4, background: AXIS_COLOR }}
                    />

                    {layout.ranges.map((r) => (
                        <React.Fragment key={`range-${r.key}`}>
                            <div
                                className="tw-absolute tw-rounded-full"
                                style={{
                                    left: r.x0,
                                    top: axisY - 2,
                                    width: Math.max(r.x1 - r.x0, 2),
                                    height: 4,
                                    background: r.color,
                                    opacity: 0.5,
                                    zIndex: 1,
                                }}
                            />
                            <div
                                className="tw-absolute tw-rounded-full"
                                style={{
                                    left: r.x1 - 5,
                                    top: axisY - 5,
                                    width: 10,
                                    height: 10,
                                    background: "#ffffff",
                                    border: `2px solid ${r.color}`,
                                    zIndex: 1,
                                }}
                            />
                        </React.Fragment>
                    ))}

                    {layout.ticks.map((x, i) => (
                        <div
                            key={i}
                            className="tw-absolute"
                            style={{
                                left: x - 1,
                                top: axisY - TICK_H / 2,
                                width: 2,
                                height: TICK_H,
                                background: AXIS_COLOR,
                                opacity: 0.85,
                            }}
                        />
                    ))}

                    {layout.yearLabels.map((y) => {
                        if (!y.show) return null;
                        return (
                            <div
                                key={y.year}
                                className="tw-absolute tw-text-center tw-whitespace-nowrap"
                                style={{
                                    left: y.x - 40,
                                    width: 80,
                                    top: axisY + (y.big ? 16 : 14),
                                    fontSize: y.big ? 24 : 11,
                                    fontWeight: y.big ? 600 : 400,
                                    color: y.big ? "#1A2027" : "#5A6A7A",
                                    lineHeight: 1.1,
                                }}
                            >
                                {y.year}
                            </div>
                        );
                    })}

                    {layout.dots.map((d) => (
                        <div
                            key={d.ev._key}
                            className="tw-absolute tw-rounded-full tw-cursor-pointer"
                            style={{
                                left: d.x - DOT_R,
                                top: axisY - DOT_R,
                                width: DOT_R * 2,
                                height: DOT_R * 2,
                                background: catColor(d.ev),
                                border: "2.5px solid #ffffff",
                                boxShadow: "0 1px 4px rgba(15, 23, 42, 0.35)",
                                zIndex: 2,
                            }}
                            onMouseEnter={showTip(d.ev, "above")}
                            onMouseLeave={() => setHover(null)}
                        />
                    ))}

                    {layout.chips.map((c) => (
                        <div
                            key={c.ev._key}
                            className="tw-absolute tw-rounded-md tw-text-white tw-font-semibold tw-truncate tw-text-center tw-cursor-pointer tw-shadow-card"
                            style={{
                                left: c.x,
                                top: c.y,
                                width: c.w,
                                height: CHIP_H,
                                lineHeight: `${CHIP_H}px`,
                                background: catChip(c.ev),
                                fontSize: 12,
                                padding: "0 10px",
                                boxSizing: "border-box",
                                zIndex: 2,
                            }}
                            onMouseEnter={showTip(c.ev, c.side)}
                            onMouseLeave={() => setHover(null)}
                        >
                            {c.ev.text}
                        </div>
                    ))}

                </div>
            </div>

            {hover && tip && ReactDOM.createPortal(
                <div
                    className="tw-bg-paper tw-rounded-brand tw-border tw-border-solid tw-border-line tw-pointer-events-none"
                    style={{
                        position: "fixed",
                        left: Math.min(
                            Math.max(hover.cx, Math.min(140, window.innerWidth / 2)),
                            Math.max(window.innerWidth - 140, window.innerWidth / 2)
                        ),
                        ...((hover.side === "above" && hover.top > 180) ||
                        (hover.side === "below" && window.innerHeight - hover.bottom < 180)
                            ? { bottom: window.innerHeight - hover.top + 10 }
                            : { top: hover.bottom + 10 }),
                        transform: "translateX(-50%)",
                        width: 260,
                        padding: "10px 12px",
                        boxShadow: "0 6px 20px rgba(0, 0, 0, 0.14)",
                        fontSize: 12,
                        color: "#111827",
                        zIndex: 9999,
                    }}
                >
                    <div className="tw-font-bold tw-break-words" style={{ fontSize: 13, color: tipColor, marginBottom: 6 }}>
                        {tip.title}
                    </div>
                    {tip.badge ? (
                        <span
                            className="tw-inline-block tw-rounded-full tw-font-semibold"
                            style={{ background: tipCfg.bg, color: tipCfg.color, fontSize: 11, padding: "2px 8px", marginBottom: 8 }}
                        >
                            {tip.badge}
                        </span>
                    ) : null}
                    {(Array.isArray(tip.rows) ? tip.rows : []).map((r, i) => (
                        <div key={i} className="tw-flex tw-gap-1.5" style={{ marginTop: 3, lineHeight: 1.4 }}>
                            {r.label ? <span className="tw-flex-shrink-0" style={{ color: "#6b7280" }}>{r.label}:</span> : null}
                            <span className="tw-font-medium tw-break-words tw-min-w-0 tw-inline-flex tw-items-center tw-gap-1.5" style={{ color: "#111827" }}>
                                {r.flag ? <FlagImg code={r.flag} /> : null}
                                {r.value}
                            </span>
                        </div>
                    ))}
                    <div
                        style={{ marginTop: 8, paddingTop: 6, borderTop: "1px solid #e5e7eb", color: "#6b7280", fontSize: 11 }}
                    >
                        <div>
                            {hover.ev.singleDate
                                ? `${lbl.tipData}: ${hover.ev.date.format("DD/MM/YYYY")}`
                                : `${lbl.tipPeriudha}: ${hover.ev.date.format("DD/MM/YYYY")} - ${hover.ev.endUnknown ? lbl.tipNA : (hover.ev.dateEnd ? hover.ev.dateEnd.format("DD/MM/YYYY") : lbl.tipVazhdon)}`}
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </div>
    );
};

export default TimelineChart;